// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1fIAR","dragIcon":"Choice_dragIcon__2XII8","left":"Choice_left__3Qao4","input":"Choice_input__5YV49"};